import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const PILETYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.PileType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.PileType.Code')
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const PILETYPE_CONFIG = {
  entityName: 'PileType',
  localizationKey: 'Planning::Entity.PileType',
  fields: PILETYPE_FIELDS,
  permission: 'PlanningLocation.PileTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
